(function () {
  'use strict';
  /**
   * @ngdoc object
   * @name simUtilizationReport.controller:SimUtilizationReportCtrl
   *
   * @description
   *
   */
  angular
    .module('simUtilizationReport')
    .controller('SimUtilizationReportCtrl', SimUtilizationReportCtrl);

  function SimUtilizationReportCtrl($sce, CommonLogicService,crewScheduleService, CommonMasterData,MessageService,TrainingScheduleService,EventManagerService,TrainingProgramsService,$timeout,CrewingHelper,applicationConstants,CrewingAdaptor,RemoteService, $stateParams, StorageServices) {

    var vm = this;

    vm.model={
      showSearchArea:false,
      searchParams:{},
      flag:'',
      masterList: {
        crewNameList: [],
        crewTypeList: [],
      },
      aircraftTypes:'',
      trainingProgramCode:'',
      trainingProgramDesc:'',
      trainingCrewType:'',
      trainingLocationList:'',
      traineesList:'',
      trainersList:''
    };

    vm.changeSearchField = function (searchParams, flag) {
      var acModel = null;
      if(!!searchParams.aircraftModelDetails && searchParams.aircraftModelDetails !== " "){
        acModel = _.find(vm.model.aircraftTypes, {
          modelNumber : searchParams.aircraftModelDetails.model
        });

      } else {
        acModel = _.find(vm.model.aircraftTypes, {
          modelNumber : "ANY"
        });
      }

      if (flag === 'crewType') {
        vm.model.masterList.crewNameList = loadCrewList(searchParams.trainingCrewTypeDetails.crewTypeCode);
      }
    };

    vm.onSearchSimUtilization = function(searchParams){
      var reportDesign = "sim_utilization_report.rptdesign";

      var url = CommonLogicService.getReportUrl(reportDesign,
        getSearchParamMap(searchParams));
      vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["acModel"] = !!param.aircraftModelDetails && !!param.aircraftModelDetails.model?param.aircraftModelDetails.model.trim():'';
      searchParamMap["fromDate"] = !!param.startDate?param.startDate:'';
      searchParamMap["toDate"] = !!param.endDate?param.endDate:'';
      searchParamMap["trainerId"] = !!param.trainerDetails && !!param.trainerDetails.crewId?param.trainerDetails.crewId:'';
      searchParamMap["traineeId"] = !!param.traineeDetails && !!param.traineeDetails.crewId?param.traineeDetails.crewId:'';
      searchParamMap["traineeCrewType"] = !!param.trainingCrewTypeDetails && !!param.trainingCrewTypeDetails.crewTypeCode?param.trainingCrewTypeDetails.crewTypeCode:'';
      searchParamMap["locationCode"] = !!param.trainingLocationDetails && !!param.trainingLocationDetails.locationCode?param.trainingLocationDetails.locationCode:'';
      searchParamMap["programCode"] = !!param.trainingProgramDescDetails && !!param.trainingProgramDescDetails.trainingProgramCode?param.trainingProgramDescDetails.trainingProgramCode:'';
      return searchParamMap;
    }

    function getAirCraftTypes() {
      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.aircraftTypes = TrainingProgramsService.setAirCraftTypes(airCraftList);
      }, function (error) {});
    }


    function getTrainingCrewType() {
      CommonMasterData.getCrewTypeList(function (response) {
        vm.model.trainingCrewType=response
      },function () {
        console.log('Training Crew Types retrieval error');
      })
    }

    function getTrainingProgramCodes() {
      CommonMasterData.getProgramCodeList(function (response) {
        TrainingScheduleService.setTrainingProgramCodes(response);
        vm.model.trainingProgramCode=TrainingScheduleService.getTrainingProgramCodes();
      },function () {
        console.log('Training Program codes retrieval error');
      })
    }

    function getTrainingProgramDesc() {
      CommonMasterData.getTrainingDescription(function (response) {
        vm.model.trainingProgramDesc = response;
        }, function(error){
          console.log("Training Program Description retrieval error" + error);
        }
      )
    }

    function getTrainingLocationList() {
      CommonMasterData.getTrainingLocationList(function (response) {
        TrainingScheduleService.setTrainingLocationList(response);
        vm.model.trainingLocationList=TrainingScheduleService.getTrainingLocationList();
      },function () {
        console.log('Training Location retrieval error');
      })
    }

    function getTrainersList() {
      CommonMasterData.getTrainerList(function (response) {
        TrainingScheduleService.setTrainersList(response);
        vm.model.trainersList=TrainingScheduleService.getTrainersList();
      },function () {
        console.log('Trainers retrieval error');
      })
    }

    function getCrewTypeList(){
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });
    }

    function loadCrewList(crewType) {
      var param = {};
      param.crewType = '';
      param.active = true;

      if (!!crewType) {
        param.crewType = crewType;
        CommonMasterData.loadCrewList(param,
          function (response) {
            vm.model.masterList.crewNameList = crewScheduleService.adaptCrewList(response);
          }, function () {
            console.log('Crew list retrieval error');
          });
      } else {
        vm.model.masterList.crewNameList = [];
      }
    };

    function init() {
      getAirCraftTypes();
      getTrainingCrewType();
      getTrainingProgramCodes();
      getTrainingLocationList()
      getTrainersList();
      getCrewTypeList();
      getTrainingProgramDesc();
    }
    init();
  }
}());
